import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';
import { Button } from 'components/Base';
import env from 'consts/env';
import { unregister } from '../serviceWorker';

const useStyles = makeStyles({
  content: {
    position: 'fixed',
    height: '20px',
    right: '0',
    backgroundColor: 'white',
    zIndex: 10001,
    top: '72px',
    display: 'flex',
    alignItems: 'center',
    padding: '13px',
    borderRadius: '25px 0 0 25px',
    boxShadow: '5px 5px 15px 5px rgba(0,0,0,0.24)'
  },
  btn: {
    marginLeft: '1rem',
    marginRight: '1rem',
    padding: '0.2rem',
    borderRadius: '50px'
  }
});

const buildDateGreaterThan = (latestDate: any, currentDate: any) => {
  const momLatestDateTime = moment(latestDate);
  const momCurrentDateTime = moment(currentDate);

  if (momLatestDateTime.isAfter(momCurrentDateTime)) {
    return true;
  } else {
    return false;
  }
};

const CheckCache = () => {
  const [isLatestBuildDate, setIsLatestBuildDate] = useState(true);
  const classes = useStyles();

  const refreshCacheAndReload = () => {
    if (caches) {
      caches.keys().then(names => {
        for (const name of names) {
          caches.delete(name);
        }
        unregister();
        Cookies.remove(`fint_app_date_v_${env.CURRENT_BUILD}`);
        window.location.reload();
      });
    } else {
      unregister();
      Cookies.remove(`fint_app_date_v_${env.CURRENT_BUILD}`);
      window.location.reload();
    }
  };

  useEffect(() => {
    fetch('/meta.json', {
      headers: {
        pragma: 'no-cache',
        'cache-control': 'no-cache'
      }
    })
      .then(response => response.json())
      .then(meta => {
        const latestVersionDate = meta.buildDate;
        const currentVersionDate = Cookies.get(
          `fint_app_date_v_${env.CURRENT_BUILD}`
        );

        if (currentVersionDate) {
          // check if current version in same as user
          const shouldForceRefresh = buildDateGreaterThan(
            latestVersionDate,
            Number(currentVersionDate)
          );

          if (shouldForceRefresh) {
            return setIsLatestBuildDate(false);
          }
          return setIsLatestBuildDate(true);
        } else {
          Cookies.set(
            `fint_app_date_v_${env.CURRENT_BUILD}`,
            latestVersionDate
          );
          setIsLatestBuildDate(true);
        }
      });
  }, []);

  return !isLatestBuildDate ? (
    <div className={classes.content}>
      <Typography>New version available! </Typography>
      <Button
        color="primary"
        onClick={refreshCacheAndReload}
        className={classes.btn}
      >
        Update
      </Button>
    </div>
  ) : null;
};

export default CheckCache;
